<template>
  <main class="content container-fluid">
    <div v-if="itemStatus" class="cart">
      <div class="cart-header">
        <fa icon="shopping-cart" />
        <div>
          <div class="bold">
            Ihr Warenkorb
          </div>
          <div>- Alle Produkte auf einen Blick!</div>
        </div>
      </div>
      <div v-for="(item, index) in items" :key="index" class="cart-item">
        <div class="cart-image">
          <item-images :images="item.images" width="150px" height="72px" />
        </div>
        <div class="cart-info">
          <div class="text-center">
            <strong>{{ item.name }}</strong>
          </div>
          <step-description :items="item.steps" />
          <!--<div class="align-middle" v-else> v-if="item.steps"
            <label>Quantity:</label>
            <input type="number" v-model.number="item.quantity" class="form-control" min="1" max="50" @change="changeQty(item.id)">
          </div>-->
        </div>
        <div class="cart-total-price">
          <div class="text-center">
            <price :discounted="item.price.discounted" :total="item.price.total" />
          </div>
        </div>
        <div class="cart-delete">
          <button class="btn btn-sm btn-danger" type="button" @click="removeItem(item.id)">
            <fa icon="trash" />
          </button>
        </div>
      </div>
      <div class="cart-detail">
        <i class="fa fa-truck" />
        <div>Versandkosten</div>
        <span class="text-danger"><price :total="price.delivery" /></span>
      </div>
      <delivery />
      <div class="cart-total-info">
        <div class="text-center">
          Kostenlos
        </div>
      </div>
      <div class="cart-footer">
        <div class="bold">
          Gesamtkosten:
        </div>
        <p class="text-muted">
          inkl. 19% MwSt. &amp; Versandkosten
        </p>
        <price :title="zaunTitle" :discounted="price.discounted + price.delivery" :total="price.total + price.delivery" />
        <div v-if="montageStatus" class="montage-price">
          <price :title="montageTitle" :total="montageCost" />
          <price :title="totalTitle" :total="price.discounted + montageCost" />
        </div>
      </div>
    </div>
    <div v-else class="alert alert-info">
      Leerer Korb!
    </div>
    <hr>
    <div class="row">
      <div class="col-md-6">
        <a class="btn btn-secondary" href="#!" @click="$router.go(-1)">Zurück</a>
      </div>
      <div v-if="items.length > 0" class="col-md-6 text-right">
        <router-link :to="{ name: 'checkout.customer' }" class="btn btn-primary">
          Zur Kasse
        </router-link>
      </div>
    </div>
  </main>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import StepDescription from './overview/stepDescription'
import ItemImages from './overview/itemImages'
import Delivery from './overview/delivery'
import Price from './overview/price'

export default {
  layout: 'basic',
  metaInfo () {
    return { title: 'Ihr Warenkorb' }
  },
  components: {
    StepDescription,
    ItemImages,
    Delivery,
    Price
  },
  data: () => ({
    montageTitle: 'Montage: ',
    totalTitle: 'Total: ',
    zaunTitle: 'Preis: '
  }),
  computed: {
    ...mapGetters({
      price: 'checkout/price',
      items: 'checkout/items',
      montageStatus: 'checkout/montageStatus',
      montageCost: 'checkout/montageCost',
      url: 'checkout/url',
      multiple: 'checkout/multiple'
    }),
    itemStatus () {
      if (this.items.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  mounted () {
    this.setDeliveryCountries()
  },
  methods: {
    ...mapActions({
      removeItem: 'checkout/removeItem',
      changeQty: 'checkout/changeQty',
      setDeliveryCountries: 'checkout/setDeliveryCountries'
    })
  }
}
</script>
